import { useMutation } from '@apollo/react-hooks';
import {
  UpdateArticlesRunStatusMutation,
  UpdateArticlesRunStatusMutation_updateArticlesRunStatus_articles,
  UpdateArticlesRunStatusMutationVariables
} from './__generated__/UpdateArticlesRunStatusMutation';
import { kmsClient } from 'api';
import { UPDATE_ARTICLES_RUN_STATUS_MUTATION } from './updateArticlesRunStatus.mutation';

type MutationProps = {
  onStart?: (variables: UpdateArticlesRunStatusMutationVariables) => void;
  onCompleted?: (articles: UpdateArticlesRunStatusMutation_updateArticlesRunStatus_articles[]) => void;
  onError?: (articles: UpdateArticlesRunStatusMutation_updateArticlesRunStatus_articles[], errors: string[]) => void;
};

export const useUpdateArticlesRunStatus = ({ onStart, onCompleted, onError }: MutationProps) => {
  const [updateArticlesRunStatus] = useMutation<
    UpdateArticlesRunStatusMutation,
    UpdateArticlesRunStatusMutationVariables
  >(UPDATE_ARTICLES_RUN_STATUS_MUTATION, {
    client: kmsClient,
    onCompleted: (data) => {
      if (data.updateArticlesRunStatus?.errors?.length) {
        if (onError) onError(data.updateArticlesRunStatus.articles || [], data.updateArticlesRunStatus.errors);
      } else {
        if (onCompleted && data.updateArticlesRunStatus?.articles) onCompleted(data.updateArticlesRunStatus.articles);
      }
    },
    onError: (error) => onError && onError([], [error.message])
  });
  return (variables: UpdateArticlesRunStatusMutationVariables) => {
    if (onStart) onStart(variables);
    updateArticlesRunStatus({ variables });
  };
};
